module.exports = "/images/vendor/flag-icon-css/flags/4x3/to.svg?79354e72ad0559ef82e28d0f2e88033f";